import { render, staticRenderFns } from "./AboutTrackman.vue?vue&type=template&id=6c521db6&scoped=true"
import script from "./AboutTrackman.vue?vue&type=script&lang=js"
export * from "./AboutTrackman.vue?vue&type=script&lang=js"
import style0 from "./AboutTrackman.vue?vue&type=style&index=0&id=6c521db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c521db6",
  null
  
)

export default component.exports